import { Component, Input, SimpleChanges } from '@angular/core';
import { CultureDetails } from 'src/app/all-motivations/model/all-motivations.interface';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { AbstractMotivationsService } from 'src/app/moov-common/services/motivation/motivations.abstract.service';

@Component({
  selector: 'app-culture-details-widget',
  templateUrl: './culture-details-widget.component.html',
  styleUrl: './culture-details-widget.component.scss',
})
export class CultureDetailsWidgetComponent extends BaseComponent {
  @Input() selectedCultureId: string = '';
  cultuerDetails: CultureDetails | null = null;
  isLoading = true;

  constructor(private readonly motivationsSerivce: AbstractMotivationsService) {
    super();
  }

  ngOnInit(): void {
    this.getCultureDetails();
  }

  getCultureDetails() {
    if (!this.selectedCultureId) {
      return;
    }
    this.isLoading = true;

    this.motivationsSerivce
      .getCulture(this.selectedCultureId)
      .subscribe((cultureData) => {
        this.cultuerDetails = cultureData;
        this.isLoading = false;

        console.log(`CdW getCutureDetails cultureData is ${JSON.stringify(cultureData)}`);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.ifChanged(changes.selectedCultureId, () => this.getCultureDetails());
  }
}
